import React from "react";
import "../../styles/Accordion.css"
import AllertIscrizione from "../multitessere/AllertIscrizione";
import SpaceL from "../../commons/SpaceL";
import Space from "../../commons/Space";

function SpaAccordionPrezzi() {
    return (
        <div className="accordion d-flex flex-column m-auto" id="accordionFlushExample" style={{maxWidth: "50em"}}>
            <div className="accordion-item">
                <h2 className="accordion-header d-flex flex-row" id="headingOne"
                    style={{justifyContent: "center", textAlign: "center"}}>
                    <button className="accordion-button collapsed" type="button" data-bs-toggle="collapse"
                            data-bs-target="#collapseOne" aria-expanded="false" aria-controls="collapseOne">
                        PREZZI
                    </button>
                </h2>
                <div id="collapseOne" className="accordion-collapse collapse" aria-labelledby="headingOne"
                     data-bs-parent="#accordionFlushExample">
                    <div className="accordion-body">
                        <div className="table-container">
                            <table className="table text-center m-auto" style={{width: "20em"}}>
                                <tbody>
                                <tr style={{backgroundColor: "#F8F8F8"}}>
                                    <th scope="col">3 mesi</th>
                                    <th scope="col">6 mesi</th>
                                    <th scope="col">11 mesi</th>
                                </tr>
                                <tr style={{backgroundColor: "#F8F8F8"}}>
                                    <td>204€</td>
                                    <td>374€</td>
                                    <td>555€</td>
                                </tr>
                                </tbody>
                            </table>
                        </div>
                        <SpaceL />
                        <div className="table-container">
                            <table className="table text-center m-auto" style={{width: "15em"}}>
                                <tbody>
                                <tr style={{backgroundColor: "#F8F8F8"}}>
                                    <th scope="col">Ingresso singolo</th>
                                    <td>18€</td>
                                </tr>
                                <tr style={{backgroundColor: "#F8F8F8"}}>
                                    <th scope="col">10 ingressi</th>
                                    <td>150€</td>
                                </tr>
                                <tr style={{backgroundColor: "#F8F8F8"}}>
                                    <th scope="col">Ingresso singolo + nuoto libero</th>
                                    <td>20€</td>
                                </tr>
                                </tbody>
                            </table>
                        </div>
                        <br/>
                        <AllertIscrizione />
                    </div>
                </div>
            </div>
        </div>
    );
}

export default SpaAccordionPrezzi